export default __webpack_public_path__ + "static/media/338.69ac1c19.gif";